import { TipoSacado } from "constants/EnumTipoSacado";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import { RegistroCondominioDTO } from "types/dto/RegistroCondominioDTO";
import { RegistroUnidadeDTO } from "types/dto/RegistroUnidadeDTO";
import { RegistroUsuarioDTO } from "types/dto/RegistroUsuarioDTO";
import { SelectOptionType } from "types/select/SelectOptionType";
import * as yup from "yup";

export const AgendarContatoSchema = yup.object().shape({
  condominio: yup
    .mixed<SelectOptionType<RegistroCondominioDTO>>()
    .required(mensagemDeErroPadrao("Condominio")),
  unidade: yup
    .mixed<SelectOptionType<RegistroUnidadeDTO>>()
    .required(mensagemDeErroPadrao("Unidade")),
  responsavelAgendamento: yup
    .mixed<SelectOptionType<RegistroUsuarioDTO>>()
    .required(mensagemDeErroPadrao("Responsável pelo agendamento")),
  dataAgendamento: yup
    .date()
    .required(mensagemDeErroPadrao("Data do agendamento"))
    .typeError("Informe uma data válida"),

  horarioAgendamento: yup
    .date()
    .required(mensagemDeErroPadrao("Horário do agendamento"))
    .typeError("Informe um horário válido"),

  sacado: yup.mixed<SelectOptionType<TipoSacado>>().required(mensagemDeErroPadrao("Sacado")),
});
